import { createSelector } from 'reselect'

const flocabularySearch = state => state.flocabulary.search
const flocabularyCurrentVideosIds = state => state.flocabulary.currentVideosIds


const VIDEOS_PER_PAGE = 10

const searchSelector = createSelector(
	[ flocabularySearch, flocabularyCurrentVideosIds ],
	(search, currentVideosIds) => ({
		page: Math.ceil(currentVideosIds.length / VIDEOS_PER_PAGE) + 1,
		hasMore: currentVideosIds.length < search.totalVideosCount,
		currentVideosIds,
	})
)

export default searchSelector
